import { Controller, type Control, type FieldPath, type FieldValues } from 'react-hook-form';

import { FieldCardToggle, type CardToggleOption } from './field-card-toggle';

interface FormFieldCardToggleProps<TForm extends FieldValues, TValue extends string>
  extends Omit<
    React.ComponentProps<typeof FieldCardToggle>,
    'value' | 'onValueChange' | 'errors' | 'options'
  > {
  control: Control<TForm>;
  name: FieldPath<TForm>;
  options: CardToggleOption<TValue>[];
}

export function FormFieldCardToggle<TForm extends FieldValues, TValue extends string>({
  control,
  name,
  options,
  ...rest
}: FormFieldCardToggleProps<TForm, TValue>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FieldCardToggle<TValue>
          {...rest}
          options={options}
          value={(field.value ?? '') as TValue}
          onValueChange={(val) => {
            field.onChange(val);
            field.onBlur();
          }}
          errors={fieldState.error ? [fieldState.error] : undefined}
        />
      )}
    />
  );
}
